import React, { useEffect, useState } from "react";
import { Badge, Col, Drawer, Grid, Row, Typography } from "antd";
import { MenuUnfoldOutlined, MenuFoldOutlined } from "@ant-design/icons";
import { ReactComponent as Logo } from "../../../assets/seller/icons/mobapartner.svg";
import { ReactComponent as BellIcon } from "../../../assets/seller/icons/bell_black_outline.svg";
import { ReactComponent as CrossIcon } from "../../../assets/seller/icons/x-close.svg";
import { ReactComponent as EmptyNotificationIcon } from "../../../assets/seller/icons/no-notifications.svg";
import "./Navbar.css";
import {
  HeaderContainer,
  OpenCloseButton,
  ProfileContainer,
  LeftContainer,
  LeftContainerMobile,
} from "./NavbarStyled";
import { useNavigate } from "react-router-dom";
import ProfileDropdown from "./ProfileDropDown/ProfileDropdown";
import { showDemandRupifiUrl } from "../../../commonUtils/commonUtils";
import { SellerMainSearch } from "../SellerMainSearch/SellerMainSearch";

const { Title, Text } = Typography;

const ArrowTop = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="10.121"
    height="10.121"
    viewBox="0 0 10.121 10.121"
  >
    <path
      data-name="Line 113"
      transform="translate(1.061 1.061)"
      style={{
        fill: "none",
        stroke: "#000",
        strokelinecap: "round",
        strokelinejoin: "round",
        strokewidth: "1.5px",
      }}
      d="m0 8 8-8"
    />
    <path
      data-name="Path 45676"
      d="M7 7h8v8"
      style={{
        fill: "none",
        stroke: "#000",
        strokelinecap: "round",
        strokelinejoin: "round",
        strokewidth: "1.5px",
      }}
      transform="translate(-5.939 -5.939)"
    />
  </svg>
);

const NavbarBlank = ({ setCollapsed, collapsed }) => {
  const screens = Grid.useBreakpoint();
  const isDesktopViewport = !!screens.lg;

  const bmp_isactive = localStorage.getItem("bmp_isactive");
  const bmp_id = localStorage.getItem("bmp_id");
  const bmp_name = localStorage.getItem("bmp_name") || "";

  const [visible, setVisible] = useState(false);
  const navigate = useNavigate();

  const url = new URL(`/home/product-search/${bmp_id}`, showDemandRupifiUrl);
  url.searchParams.set("bmp", bmp_id);

  const handleNavigateDashboard = () => {
    const currentPath = window.location.pathname;
    const dashboardPath = "/seller/sellerdashboard";
    if (currentPath === dashboardPath) {
      window.location.reload();
    } else {
      navigate(dashboardPath);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      {isDesktopViewport && (
        <HeaderContainer
          className="seller-navbar-desktop"
          style={{
            backgroundColor: "#fff",
            color: "#0a243f",
            boxShadow: "0 3px 3px 0 rgba(0, 0, 0, 0.08)",
            borderBottom: "1px solid #dedede",
            padding: 0,
            height: "72px",
            minHeight: "72px",
          }}
        >
          <Row gutter={[24, 0]} style={{ margin: "0px" }} className="seller-navbar-row">
            <Col xs={12} sm={24} md={7} lg={7} xl={7} className="seller-navbar-left-col">
              <LeftContainer className="seller-navbar-left-content">
                <Logo
                  style={{ cursor: "pointer", width: "88px" }}
                  onClick={handleNavigateDashboard}
                />
                <Col className="fixed-font font-eclipse">{bmp_id} ({bmp_name})</Col>
              </LeftContainer>
            </Col>

            <Col xs={24} sm={24} md={8} lg={8} xl={8} className="seller-navbar-search-col">
              <SellerMainSearch />
            </Col>

            <Col xs={12} sm={24} md={9} lg={9} xl={9} className="header-control text-right seller-navbar-right-col">
              <ProfileContainer className="seller-navbar-actions">
                {bmp_isactive === "true" && (
                  <>
                    <Badge size="small" className="seller-online-store-wrap">
                      <a href={url.href} rel="noreferrer" target="_blank">
                        <Text className="online-store seller-online-store">
                          Your online store {ArrowTop}
                        </Text>
                      </a>
                    </Badge>

                    <Badge size="small" className="notification-badge seller-notification-wrap" count={0}>
                      <Text
                        onClick={(e) => {
                          e.preventDefault();
                          setVisible(true);
                        }}
                        className="ant-dropdown-link"
                      >
                        <BellIcon />
                      </Text>
                    </Badge>
                  </>
                )}
                <ProfileDropdown />
              </ProfileContainer>
            </Col>
          </Row>
        </HeaderContainer>
      )}

      {!isDesktopViewport && (
        <HeaderContainer
          className="pl-0"
          style={{
            backgroundColor: "#fff",
            color: "#0a243f",
            boxShadow: "0 3px 3px 0 rgba(0, 0, 0, 0.08)",
            borderBottom: "1px solid #dedede",
            padding: "10px 0 0 0",
            height: "120px",
          }}
        >
          <Row gutter={[24, 0]} style={{ margin: "0px" }}>
            <Col xs={13} sm={24} md={8} lg={8} xl={8} style={{ gap: "0rem" }}>
              <LeftContainerMobile>
                <OpenCloseButton
                  style={{ color: "#0a243f", paddingLeft: "5px" }}
                  onClick={() => setCollapsed(!collapsed)}
                >
                  {collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
                </OpenCloseButton>
                <Logo
                  style={{ cursor: "pointer", paddingBottom: "5px" }}
                  onClick={handleNavigateDashboard}
                />
              </LeftContainerMobile>
            </Col>
            <Col xs={11} sm={24} md={8} lg={8} xl={8} className="header-control text-right">
              <ProfileContainer>
                <ProfileDropdown />
              </ProfileContainer>
            </Col>
          </Row>
          <Row>
            <Col style={{ padding: "5px" }} xs={24} sm={24} md={8} lg={8} xl={8}>
              <SellerMainSearch />
            </Col>
          </Row>
        </HeaderContainer>
      )}

      <Drawer
        title={
          <Col
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Title level={4} style={{ margin: 0 }}>
              0 Notifications
            </Title>
            <Col
              onClick={() => setVisible(false)}
              style={{
                width: "48px",
                height: "48px",
                padding: "16px",
                borderRadius: "24px",
                cursor: "pointer",
              }}
            >
              <CrossIcon />
            </Col>
          </Col>
        }
        placement="right"
        open={visible}
        className="notification-drawer"
        closable={false}
        onClose={() => setVisible(false)}
      >
        <Row>
          <Col span={24} style={{ display: "flex", justifyContent: "center" }}>
            <EmptyNotificationIcon />
          </Col>
          <Col span={24} style={{ display: "flex", justifyContent: "center" }}>
            <Text className="no-notification">No new notifications!</Text>
          </Col>
        </Row>
      </Drawer>
    </>
  );
};

export default NavbarBlank;
